import { IItemsResponse } from 'src/api/types';
import { IMenuItem } from 'src/types/menu.types';

// this function is used when fetching a menu, therefore, several properties have no value
export const formatItems = (menuItems: IItemsResponse[]): IMenuItem[] =>
  menuItems.map((menuItem: IItemsResponse) => ({
    itemId: menuItem.item_id,
    name: menuItem.name,
    description: menuItem.description,
    type: menuItem.type,
    image: menuItem.asset_url,
    ranges: menuItem.ranges,
    prices: [],
    tax_rate: null,
    consumerName: undefined,
    posId: undefined,
    displayOrder: undefined,
    recipeId: undefined,
    parentItemId: null, // v2 only returns global items, i.e. with fk_parent_item_id = null
    optionGroup: [],
    deposit_return_scheme: null,
  }));
